import { Dispatch, SetStateAction, useState } from "react";
import Link from "@mui/material/Link";
import { SaleStatus } from "../../../types/sale.type";
import { useUserRole } from "../../../utils/hooks/useUserRole";
import RevertCancelDialog from "./RevertCancelDialog";

interface RevertCancelLinkProps {
  uuid: string;
  status: SaleStatus;
  setTriggerFetch: Dispatch<SetStateAction<number>>;
}

/**
 * "กู้คืนบิล" beside the status badge of a cancelled bill. Master only; the backend
 * enforces the same rule, this just hides a button nobody else can use.
 */
export default function RevertCancelLink({
  uuid,
  status,
  setTriggerFetch,
}: RevertCancelLinkProps) {
  const { isMaster } = useUserRole();
  const [open, setOpen] = useState<boolean>(false);

  if (!isMaster || status !== "cancel") return null;

  return (
    <>
      <Link
        component="button"
        type="button"
        onClick={() => setOpen(true)}
        sx={{
          color: (theme) => theme.palette.link.main,
          fontWeight: 600,
          textDecoration: "underline",
          cursor: "pointer",
          background: "none",
          border: "none",
          padding: 0,
          font: "inherit",
        }}
      >
        กู้คืนบิล
      </Link>
      <RevertCancelDialog
        open={open}
        uuid={uuid}
        onClose={() => setOpen(false)}
        onReverted={() => setTriggerFetch((prev) => prev + 1)}
      />
    </>
  );
}
